import React, { useRef } from 'react';
import { Button } from 'carbon-components-react';
import RootOfStages from './RootOfStages';
import { withRouter } from 'react-router-dom';
import './rootOfStages.scss';
import funcTranslateHelper from '../../i18next/funcTranslateHelper';

const DashboardHistory = props => {
  const { configFile, assets } = props;
  const ref = useRef(null);

  return (
    <div ref={ref} className='main-content'>
      <div className='header-style'>
        <div>
          <h2>{funcTranslateHelper('DashboardHistory.titulo')}</h2>
        </div>
        <div>
          <Button
            kind='primary'
            onClick={() => props.history.push('/dashboard')}
            type='button'
          >
            {funcTranslateHelper('Volver')}
          </Button>
        </div>
      </div>
      <div className='bx--row dashboard-box'>
        {configFile.stages.map((stage, i) => (
          <div className='bx--col column-mw' key={i}>
            <RootOfStages
              key={i}
              stages={stage}
              assets={assets}
              configFile={configFile}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default withRouter(DashboardHistory);
